import React from 'react';
import { motion } from 'framer-motion';
import { ProductMockup } from './ProductMockup';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-primary text-white min-h-[100svh] flex flex-col justify-center px-4 py-6 md:py-20" data-id="element-137">
      <div className="max-w-4xl mx-auto text-center w-full" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-3 md:mb-6" data-id="element-139">
          <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-1.5 md:px-6 md:py-2 rounded-full text-xs md:text-sm font-semibold border border-white/20" data-id="element-140">
            PROFE LISTO · STRETCHING 360
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-2xl sm:text-4xl md:text-6xl font-black mb-4 md:mb-8 leading-tight" data-id="element-141">
          Todo tu año de stretching resuelto de una vez.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-4 md:mb-8" data-id="element-142">
          <div className="w-44 sm:w-64 md:w-full md:max-w-md" data-id="element-143">
            <ProductMockup data-id="element-144" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-145">
          <h2 className="text-lg sm:text-2xl md:text-3xl font-bold mb-2 md:mb-4 text-highlight leading-tight" data-id="element-146">
            Megapack STRETCHING 360 — Pack Anual Elite Completo
          </h2>
          <p className="hidden md:block text-lg md:text-xl mb-8 text-white/90 max-w-2xl mx-auto" data-id="element-147">
            Megapack STRETCHING 360 — El sistema completo de planificación y
            fichas listas para el instructor de stretching argentino
          </p>

          <div className="flex flex-wrap gap-2 md:gap-4 justify-center mb-4 md:mb-8 text-xs md:text-sm font-medium" data-id="element-148">
            <span className="flex items-center gap-1.5 bg-white/10 px-3 py-1.5 md:px-4 md:py-2 rounded-lg" data-id="element-149">
              📄 PDF
            </span>
            <span className="flex items-center gap-1.5 bg-white/10 px-3 py-1.5 md:px-4 md:py-2 rounded-lg" data-id="element-150">
              ⚡ Acceso Inmediato
            </span>
            <span className="flex items-center gap-1.5 bg-white/10 px-3 py-1.5 md:px-4 md:py-2 rounded-lg" data-id="element-151">
              📚 12 Tomos + 6 Bonus + 2 Élite
            </span>
          </div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToPricing} className="w-full md:w-auto bg-accent text-white px-8 py-4 md:px-10 md:py-5 rounded-lg font-bold text-base md:text-xl mb-3 md:mb-6 hover:bg-accent-dark transition-colors shadow-xl" data-id="element-152">
            💪 QUIERO MI STRETCHING 360 AHORA
          </motion.button>

          <div className="text-xs md:text-sm text-white/80 mb-6 md:mb-10" data-id="element-153">
            <p data-id="element-154">
              🛡️ Garantía 7 días | 🔒 Pago seguro | 💳 Tarjetas y transferencia
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-wrap gap-3 md:gap-4 justify-center text-xs md:text-sm text-white/90 bg-white/5 py-3 md:py-4 rounded-xl" data-id="element-155">
          <span data-id="element-156">+500 profes confían</span>
          <span className="hidden md:inline" data-id="element-157">·</span>
          <span data-id="element-158">12+6 Tomos + Bonus</span>
          <span className="hidden md:inline" data-id="element-159">·</span>
          <span data-id="element-160">4.9/5 calificación ⭐</span>
          <span className="hidden md:inline" data-id="element-161">·</span>
          <span data-id="element-162">🇦🇷 Argentina MP</span>
        </motion.div>
      </div>
    </section>;
}